var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3669 8.24458C12.3669 5.9679 10.5213 4.12228 8.24461 4.12228C5.96793 4.12228 4.12231 5.9679 4.12231 8.24458C4.12231 10.5213 5.96793 12.3669 8.24461 12.3669C10.5213 12.3669 12.3669 10.5213 12.3669 8.24458ZM5.49657 8.2446C5.49657 6.72681 6.72698 5.4964 8.24476 5.4964C9.76255 5.4964 10.993 6.72681 10.993 8.2446C10.993 9.76239 9.76255 10.9928 8.24476 10.9928C6.72698 10.9928 5.49657 9.76239 5.49657 8.2446Z",
    fill: "#981BAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4892 8.48045C16.4892 3.01622 12.3669 0 8.24459 0C4.1223 0 0 3.01622 0 8.48045C0 11.8846 2.39986 16.2218 7.19959 21.4922C7.72519 22.0693 8.61914 22.1111 9.19627 21.5855C9.22882 21.5558 9.25995 21.5247 9.28959 21.4922L9.71932 21.0156C14.2326 15.9598 16.4892 11.7814 16.4892 8.48045ZM1.37428 8.48044C1.37428 4.20641 4.42099 1.37409 8.24477 1.37409C12.0686 1.37409 15.1153 4.20641 15.1153 8.48044C15.1153 11.4578 12.8637 15.527 8.27124 20.5695L8.25296 20.5789C8.23975 20.5817 8.22545 20.5776 8.21571 20.5669C3.62585 15.5271 1.37428 11.4578 1.37428 8.48044Z",
    fill: "#981BAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2444 10.9928C11.08 10.9928 12.9348 12.2426 13.644 14.6655L13.7207 14.9503L13.8855 15.6173L12.5515 15.9468L12.3867 15.2798C11.8999 13.3092 10.5806 12.3669 8.2444 12.3669C6.00981 12.3669 4.70555 13.2291 4.17029 15.0286L4.10205 15.2798L3.93726 15.9468L2.60327 15.6173L2.76806 14.9503C3.41281 12.3406 5.29971 10.9928 8.2444 10.9928Z",
    fill: "#981BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3fd4b6d5ef443f545177d04d7addd126.svg";
export { ForwardRef as ReactComponent };